import { pushToDataLayer } from '@/lib/pushToDataLayer.ts';

export const trackIndustrySelected = (industryName: string) => {
  pushToDataLayer({
    event: 'industry_selected',
    industry: industryName,
  });
};
